import menuTree from '@/components/system/role/menu';

const filterMenu = (menuList, menuCode) => {
  return menuList.filter(item => {
    return menuCode.indexOf(item.id) > -1
  }).map(item => {
    item = Object.assign({}, item)
    if (item.children) {
      item.children = filterMenu(item.children, menuCode)
    }
    return item
  })
}

export default {
  data() {
    return {
      mixInNewDataTree: []
    }
  },
  mounted() {

  },
  methods: {
    getRoleMenus(noCache = false) {
      return new Promise((resolve, reject) => {
        let menu = this.$store.state.allMenuList;
        if (noCache === false && menu && menu.data.length) {
          resolve(menu);
        } else {
          /*let res = {
            data: menuTree
          };*/
          this.mixInNewDataTree = JSON.parse(JSON.stringify(menuTree));
          // filterMenu(this.mixInNewDataTree, this.$store.state.permissions);
          let res = {
            data: filterMenu(this.mixInNewDataTree, this.$store.state.permissions)
          };
          this.$store.commit('initPermList', res);
          resolve(res);
          let getParentIds = (menus, parentsIds) => {
            menus.forEach(i => {
              if (i.children) {
                parentsIds.push(i.id);
                getParentIds(i.children, parentsIds);
              }
            });
          };
          let setParentIds = (menus) => {
            let parentIds = [];
            getParentIds(menus, parentIds);
            this.$store.commit('initMenuParentIds', parentIds);
          };
          setParentIds(res.data);
        }
      });
    }
  }
};
